// libs
import styled, { css } from "styled-components";
import {
  color,
  ColorProps,
  flexbox,
  FlexboxProps,
  layout,
  LayoutProps,
  position,
  PositionProps,
  space,
  SpaceProps,
} from "styled-system";

interface FlexContainerProps
  extends FlexboxProps,
    SpaceProps,
    LayoutProps,
    PositionProps,
    ColorProps {}

export interface FlexItemProps
  extends FlexboxProps,
    SpaceProps,
    LayoutProps,
    PositionProps,
    ColorProps {}

export const FlexContainer = styled.div<FlexContainerProps>`
  ${flexbox}
  ${space}
  ${layout}
  ${position}
  ${color}
  display: flex;
`;

export const FlexItem = styled.div<FlexItemProps>`
  ${flexbox}
  ${space}
  ${layout}
  ${position}
  ${color}
`;
